import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=798c8ae0&scoped=true"
import script from "./Accountant.vue?vue&type=script&lang=js"
export * from "./Accountant.vue?vue&type=script&lang=js"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=798c8ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c8ae0",
  null
  
)

export default component.exports